const KeyBoard = ({ letters = null, size = "w-full", onClick = null, children, style = {}, defaultClass = "bg-white leading-none text-2xl font-semibold uppercase", autoHeight = true }) => {
  const getClass = () => {
    if (!letters || typeof children !== 'string') return defaultClass;

    const result = letters[children];

    if (result) {
      return {
        'R': 'bg-success text-white leading-none text-2xl font-semibold uppercase',
        'P': 'bg-warning text-white leading-none text-2xl font-semibold uppercase',
        'W': 'bg-grey-mid leading-none text-2xl font-semibold uppercase cursor-not-allowed'
      }[result];
    } else {
      return defaultClass;
    }
  }

  return (
    <div className={`${size} mb-2 px-1 select-none disable-dbl-tap-zoom`} style={style}>
      {children && (
        <button className={`block w-full rounded shadow hover:shadow-lg focus:outline-none transition ease-in-out duration-100 relative ${autoHeight ? 'auto-height' : ''} ${getClass()}`} onClick={onClick}>
          <span className="absolute inset-0 flex items-center justify-center">
            {children}
          </span>
        </button>
      )}
    </div>
  )
}

export default KeyBoard;
